/**
 * localeType说明:
 * pub: src/public使用，如页面信息、搜索、过滤等
 * nav: 主菜单
 * tab: Manager tab名
 * button:
 * 
 * common:
 */

require('./ext-locale-pub')

const allLocales = {
	zh_CN: {
		name: '中文',
		pubMod: () => import(/* webpackChunkName: "chunks/public/locale/syncFusion" */'@syncfusion/ej2-base')
			.then(mod => import(/* webpackChunkName: "chunks/public/locale/zh_CN" */'./syncfusion/zh.json')
				.then(zh => mod.L10n.load(zh.default))
				.then(() => {
					const { loadCldr, setCulture } = mod
					setCulture('zh')
					const args = []
					args.push(import(/* webpackChunkName: "chunks/public/locale/zh_CN" */'./cldr-data/main/zh/ca-gregorian.json'))
					args.push(import(/* webpackChunkName: "chunks/public/locale/zh_CN" */'./cldr-data/main/zh/numbers.json'))
					args.push(import(/* webpackChunkName: "chunks/public/locale/zh_CN" */'./cldr-data/main/zh/timeZoneNames.json'))

					args.push(import(/* webpackChunkName: "chunks/public/locale/syncFusion" */'./cldr-data/supplemental/numberingSystems.json'))
					args.push(import(/* webpackChunkName: "chunks/public/locale/syncFusion" */'./cldr-data/supplemental/weekData.json'))

					return Promise.all(args).then(values => {
						loadCldr(...values.map(v => v.default))
					}).then(() => import(/* webpackChunkName: "chunks/public/locale/zh_CN" */'./zh_CN'))
					// loadCldr(gregorian, timeZoneNames, numberingSystems, numbers, weekData);
				})
			)
	},
	en: {
		name: 'En',
		pubMod: () => import(/* webpackChunkName: "chunks/public/locale/en" */'./en'),
	}
}

let appLocales = {
	// zh_CN: '中文'
}

// 设置当前使用语言
export const setLocale = locale => {
	const curr = Tyan.psnCfg.locale

	curr !== locale && (Tyan.setPsnCfg({ locale }), window.location.reload())
}

// 读取当前使用语言
export const getLocale = () => {
	// 读取locale, 如果不存在,则设置为'zh_CN'，并重新加载
	const locale = Tyan.psnCfg.locale || Object.keys(appLocales)[0]
	if (appLocales[locale])
		return locale
	setLocale(Object.keys(appLocales)[0])
	// setLocale('zh_CN')
	return undefined
}

// 设置可用语言及相应的翻译模块
export const setLocales = locales => {
	Object.keys(appLocales).forEach(o => delete appLocales[o])
	let loc
	for (let [key, mod] of Object.entries(locales)) {
		if (!(loc = allLocales[key])) throw `无效语言代码 ${key}`
		appLocales[key] = loc.name
		loc.mod = mod
	}
	!Object.keys(appLocales).length && (appLocales.zh_CN = '中文')
}

// 读取可用语言用于呈现及切换
export const getLocales = () => {
	return { ...appLocales }
}


// 读取指定语音的前台所有文本翻译内容，返回一个promise，promise的resolve参数即为所有文本翻译内容
export const getFrontLocaleText = locale => {
	// 纯化数据，即去除debug、noCache、config
	const purifyData = ({ debug, noCache, config, ...data } = {}) => data

	return Promise.all([
		allLocales[locale].pubMod()
			.then(pubMod => purifyData(pubMod.pub)),
		allLocales[locale].mod()
			.then(appMod => purifyData(appMod.default)),
	]).then(arr => {
		arr = arr.map(o => JSON.parse(JSON.stringify(o)))
		const data = Ext.merge(...arr)

		Object.entries(data).forEach(([type, typeValue]) => {
			data[type] = { text: typeValue?.text || {} }
		})

		return data
	})
}

// 装载当前语言处理模块
export const loadLocale = () => {
	// pub、 app data or fn
	let pubData = undefined			// 公共数据
	let appData = undefined			// 应用数据
	// let svrData = undefined 		// 服务端数据

	let debug = false				// 是否调试，即对未翻译的内容增加前缀T
	let noCache = false					// 是否不做缓存
	let config = {}							// 其它配置项，暂时无内容

	// 检查当前locale
	const locale = getLocale()
	if (!locale) return Promise.resolve()

	// 纯化数据，即去除debug、noCache、config
	const purifyData = ({ debug: debugParam, noCache: noCacheParam, config: configParam, ...data } = {}) => {
		debug = debugParam ?? debug
		noCache = noCacheParam ?? noCache
		config = Ext.merge({}, config, configParam ?? {})

		return data
	}

	const genT = (pub, app) => {
		const doDebug = debug ? o => `T ${o}` : o => o

		let tData = Ext.merge({
			common: {
				text: {
					'&nbsp': '&nbsp',
					' ': ' '
				},
			}
		}, pub && typeof pub !== 'function' && pub || {}, app && typeof app !== 'function' && app || {})
		// 整理所有text下属性为函数
		Object.values(tData).forEach(type => {
			if (type.constructor === Boolean) return
			const text = type.text = type.text || {}
			Object.entries(text).forEach(([key, value]) => {
				typeof value !== 'function' && (text[key] = () => value)
			})
			type.regexp = Object.entries(type.regexp || {})
		})

		tData._cache = {}
		let temp = undefined

		const pubFn = (...args) => args[0] && (tByData(...args) || pub(...args) || cache(...args))
		const appFn = (...args) => args[0] && (tByData(...args) || app(...args) || cache(...args))
		const appFnPubFn = (...args) => args[0] && (tByData(...args) || app(...args) || pub(...args) || cache(...args))
		const dataPubFn = (...args) => args[0] && (tByData(...args) || pub(...args) || cache(...args))
		const dataAppFn = (...args) => args[0] && (tByData(...args) || app(...args) || cache(...args))
		const tByDataCache = (...args) => args[0] && (tByData(...args) || cache(...args))

		const cache = (v, type) => {
			// 将非有效type转换为'common'
			type = type && typeof type == 'string' ? type : 'common'
			// 未找到匹配，置于cache，返回v
			temp = tData._cache[v] = tData._cache[v] || {}
			temp[type] = true
			!noCache && trySaveCache(v, type)

			return doDebug(v)
		}

		const tByData = (v, type, ...args) => {
			// 首先检查是否存在cache(即曾经处理过但没有任何匹配的数据)，如果存在相同localType数据则直接返回原值
			if (tData._cache[v] && tData._cache[v][type])
				return doDebug(v)

			// 优先根据type处理，然后在common中处理
			for (const locale of [tData[type], tData.common].filter(o => o)) {
				// 直接文本存在则直接返回
				if (locale.text && locale.text[v]) return locale.text[v](type, ...args)
				// 正则表达式处理
				let m
				for (let [exp, fn] of locale.regexp) {
					if (m = v.match(exp)) {
						// console.log('regexp:', v, type, exp, m)
						return fn(type, m)
					}
				}
			}

			return undefined
		}

		const tFn = !pub
			? (app && typeof app === 'function' ? appFn : tByDataCache)
			: typeof pub === 'function'
				? (!app ? pubFn : typeof app === 'function' ? appFnPubFn : dataPubFn)
				: app && typeof app === 'function' ? dataAppFn : tByDataCache

		// Tyan.t = (...args) => {
		// 	if (args[0] && args[0].includes('博世汽车系统')) {
		// 		console.log('t:', args)
		// 	}
		// 	const ret = tFn(...args)
		// 	return ret
		// }

		Tyan.t = tFn
		Tyan.localeConfig = config
	}

	return allLocales[locale].pubMod()
		.then(pubMod => pubData = purifyData(pubMod.pub))		// 加载公共数据
		.then(() => allLocales[locale].mod ? allLocales[locale].mod() : {})	// 加载应用数据
		.then(appMod => appData = appMod && purifyData(appMod.default))
		.then(() => {		// 加载服务端数据
			return new Promise(resolve => {
				Tyan.doPostEvent('GetLocale',
					{
						data: { name: locale },
						onEnd: ({ errorMessage, id, name, version, value }) => {
							const svrData = purifyData(JSON.parse(value ?? '{}'))
							// 删除后台数据中所有空值
							Object.entries(svrData).forEach(([type, typeValue]) => {
								Object.entries(typeValue).forEach(([kind, kindValue]) => {
									Object.entries(kindValue).forEach(([key, value]) => {
										!value && delete kindValue[key]
									})
									!Object.keys(kindValue).length && delete typeValue[kind]
								})
								!Object.keys(typeValue).length && delete svrData[type]
							})

							// console.log('svrData:', svrData)
							// console.log('oldAppData:', appData)
							appData = Ext.merge({}, appData, svrData)
							// console.log('appData:', appData)
							resolve()
						}
					})
			})
		})
		.then(() => {
			true && (pubData || appData) && genT(pubData, appData)
		})
}

// 保存未翻译的内容
let cacheToSave = {}
let tmrSaveCache = undefined

const saveCache = () => {
	tmrSaveCache = null
	console.warn('miss locale', Tyan.getLocale(), { ...cacheToSave })
	// cacheToSave = {}
}

const trySaveCache = (v, type) => {
	// console.warn('cache:', v, type)
	tmrSaveCache && (clearTimeout(tmrSaveCache), tmrSaveCache = null)
	cacheToSave[v] = cacheToSave[v] || {}
	cacheToSave[v][type] = true
	tmrSaveCache = setTimeout(saveCache, 3000)
}

